<div class="template-editor-item">
  <mat-icon [inline]="true" cdkDragHandle class="template-editor-item__icon">drag_indicator</mat-icon>

  <div
    #itemName
    [attr.contenteditable]="editMode"
    class="template-editor-item__text nowrap fs s14 text-color gray"
    (click)="enterEditMode()"
    (blur)="leaveEditMode(itemName.textContent)"
    (keydown)="nameChanged($event)"
  >
    {{ item.title }}
  </div>

  <div
    class="ml-auto"
    (menuOpened)="openRatingPopup = true"
    (menuClosed)="openRatingPopup = false"
    [matMenuTriggerFor]="contextMenu"
  >
    <button
      [ngClass]="{ 'rating-icon--open': openRatingPopup, 'rating-icon--active': !!ratingGroup }"
      class="rating-icon"
      mat-icon-button
      (click)="removeRatingGroup($event)"
    >
      <app-icon [svg]="EIcon.FAMILY_STAR"></app-icon>
    </button>
  </div>

  <mat-menu #contextMenu="matMenu" class="menu-with-backdrop rating-groups">
    <button class="rating-groups__group rating-groups__group--title" mat-menu-item>Rating groups:</button>
    <button
      class="rating-groups__group"
      *ngFor="let group of ratingGroups$ | async"
      mat-menu-item
      (click)="addRatingGroup(group)"
    >
      {{ group.name }}
    </button>
  </mat-menu>

  <button class="remove" mat-icon-button (click)="removeClick()">
    <app-icon [svg]="EIcon.DELETE_FOREVER"></app-icon>
  </button>
</div>
<app-template-editor-rating-group
  *ngIf="ratingGroup"
  [ratingGroup]="ratingGroup"
  (ratingGroupChange)="ratingGroupChange($event)"
></app-template-editor-rating-group>
